import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UrlService} from './url.service';

@Injectable()
export class AlgorithmService {

    private BASE_URL: string;

    private algorithmList: Array<any> = null;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/algorithms';
    }

    list() {
        return this.http.get(this.BASE_URL);
    };

    getByName(algorithmNames) {
        let params = new HttpParams();

        params = params.set('namesList', algorithmNames);

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/listByName', requestOptions);
    }

    boxScoreRanges(algorithmNames) {
        let params = new HttpParams();

        params = params.set('algorithmNameList', algorithmNames);

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/statistics/', requestOptions);
    }

}
